import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { Login } from "../login/login";

@Component({
  selector: 'app-opening-screen',
  templateUrl: './opening-screen.component.html',
  styleUrls: ['./opening-screen.component.scss'],
  imports: [
    CommonModule,
    Login
]
})
export class OpeningScreenComponent implements OnInit {

  isLogin: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.isLogin = true
    }, 2000)

    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/chat'])
    }
  }

}
